import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesVentas() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Pedidos", items: [
      { label: "Pedidos", icon: "fas fa-shopping-basket", color: "#3b82f6", href: "/ListadoPedidos", desc: "Listado de pedidos", enabled: !!user.menu_pedidos },
      // "Pedidos por Cliente" (/ListadoPedidosCliente) se quito: la vista nunca
      // existio ni estaba registrada en Routes.js, el boton llevaba a una
      // pantalla en blanco. Venia asi desde antes de la migracion de menus.
      { label: "Analisis Pedidos", icon: "fas fa-search", color: "#6366f1", href: "/AnalisisArticulosPedidos", desc: "Analisis por articulo", enabled: !!user.menu_ventas },
      { label: "Listo para Surtir", icon: "fas fa-dolly", color: "#f59e0b", href: "/ListoSurtir", desc: "Surtibles por bodega", enabled: !!user.menu_surtidos },
      { label: "Listo Surtir Cliente", icon: "fas fa-dolly", color: "#f59e0b", href: "/ListoSurtirCliente", desc: "Surtible por cliente", enabled: !!user.menu_surtidos },
    ]},
    { section: "Surtidos y Notas", items: [
      { label: "Surtir", icon: "fas fa-truck-moving", color: "#10b981", href: "/ListadoPendienteSurtir", desc: "Pendientes de surtir", enabled: !!user.surtidos_create },
      { label: "Notas", icon: "fas fa-file-invoice-dollar", color: "#10b981", href: "/ListadoSurtidos", desc: "Notas de venta", enabled: !!user.menu_surtidos },
      { label: "Venta Directa", icon: "fas fa-file-invoice-dollar", color: "#14b8a6", href: "/VentaDirectaCreate", desc: "Venta sin pedido", enabled: !!user.menu_ventas },
      { label: "Notas de Cargo", icon: "fas fa-money-check-alt", color: "#f59e0b", href: "/ListadoNotasCargo", desc: "Cargos al cliente", enabled: !!user.notasCargo },
      { label: "Reporte Surtidos", icon: "fas fa-money-check-alt", color: "#3b82f6", href: "/ReporteSurtidos", desc: "Reporte de surtidos", enabled: !!user.menu_surtidos },
    ]},
    { section: "Devoluciones", items: [
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevoluciones", desc: "Devoluciones de cliente", enabled: !!user.menu_devoluciones },
      { label: "Articulos Devueltos", icon: "fas fa-undo-alt", color: "#ef4444", href: "/AnalisisArticulosDevoluciones", desc: "Analisis de devoluciones", enabled: !!user.menu_devoluciones },
    ]},
    { section: "Precios y Análisis", items: [
      { label: "Ultimo Precio Cliente", icon: "fas fa-dollar-sign", color: "#8b5cf6", href: "/ReporteUltimoPrecio", desc: "Precio por cliente", enabled: !!user.menu_ventas },
      { label: "Ultimo Precio Modelo", icon: "fas fa-tshirt", color: "#8b5cf6", href: "/ReporteUltimoPrecioArticulo", desc: "Precio por modelo", enabled: !!user.menu_ventas },
      { label: "Reporte Precios", icon: "fas fa-dollar-sign", color: "#8b5cf6", href: "/ReportePrecios", desc: "Comparativo de precios", enabled: !!user.menu_surtidos },
      { label: "Analisis Exportacion", icon: "fas fa-dolly", color: "#06b6d4", href: "/AnalisisArticulosPedidosExpo", desc: "Analisis exportacion", enabled: !!user.menu_surtidos },
      { label: "Analisis Global", icon: "fas fa-dolly", color: "#06b6d4", href: "/AnalisisArticulosPedidosGlobal", desc: "Analisis global", enabled: !!user.menu_surtidos },
    ]},
    { section: "Clientes", items: [
      { label: "Clientes", icon: "fas fa-user-tie", color: "#64748b", href: "/Clientes", desc: "Padron de clientes", enabled: !!user.menu_clientes },
      { label: "Grupos", icon: "fas fa-users", color: "#64748b", href: "/Grupos", desc: "Grupos de clientes", enabled: !!user.grupos },
      { label: "Departamentos", icon: "fas fa-store", color: "#64748b", href: "/DepartamentosClientes", desc: "Departamentos", enabled: !!user.grupos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Ventas"
      descripcion="Pedidos, surtidos, notas y devoluciones"
      icono="fas fa-store"
      color="#10b981"
      secciones={SECCIONES}
    />
  );
}

export default BotonesVentas;
